import styled from 'styled-components'

export const HeaderInformation = styled.div`
  .title {
    text-align: center;
    margin-bottom: 20px;
    margin: 0;
  }
  .description {
    text-align: center;
    margin: 20px 0;
  }
`
